import ConnectionRepository from '../../repositories/ConnectionRepository';
// import Vue from 'vue'

export default {
	namespaced: true,
	state: {

	},
	mutations: {

	},
	actions: {
		fetchAll ({ commit, getters }) {
			return ConnectionRepository.all(null, true);
		},
		deactivate ({ commit, getters }, id) {
			return ConnectionRepository.deactivate(id);
		},
		fetchDevices ({ commit, getters }, request) {
			return ConnectionRepository.fetchDevices(request.connectionId, request.page, request.withAttribute);
		},
		fetchDeviceTypeAttributes ({ commit, getters }, connectionId) {
			return ConnectionRepository.fetchDeviceTypeAttributes(connectionId);
		},
		/**
		 * fetch information about a connection
		 *
		 * @param commit vuex commit function
		 * @param getters vuex getters object
		 * @param {int} id id of the connection
		 * @returns {Promise<Array|Object|string>}
		 */
		fetchConnection ({ commit, getters }, id) {
			return ConnectionRepository.fetchConnection(id);
		},
		/**
		 * make a request to sync the connections in the list
		 * of ids
		 *
		 * @param getters vuex getters object
		 * @param {array} ids list of connection ids
		 * @returns {Promise<void>}
		 */
		syncSelected ({ getters }, ids) {
			return ConnectionRepository.syncSelectedConnections(ids);
		}
	},
	getters: {
	}
};
